/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import IndexedDB from "@/helpers/IndexedDB.js";
export default {
	async savePreferencesOnIndexedDB({commit, state, dispatch}) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const preferences = await dispatch("getPreferences");
					if (preferences) {
						commit("UPDATE_PREFERENCE", {...state, ...preferences});
						dispatch("updatePreferences", {...state, ...preferences});
						resolve(preferences);
					} else {
						const userInfo = JSON.parse(localStorage.getItem("userInfo"));
						await IndexedDB.save("preferences", state, userInfo.uid);
						commit("UPDATE_PREFERENCE", state);
						resolve(state);
					}
				} catch (error) {
					console.error(error);
					reject(error);
				}
			})();
		});
	},
	updatePreferences({commit, state}, payload) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					await IndexedDB.update("preferences", payload, userInfo.uid);
					commit("UPDATE_PREFERENCE", payload);
					resolve(payload);
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
	async saveCompanyConfigListPreferences({commit, state, dispatch}, payload) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const preferences = await dispatch("getPreferences");
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));

					if (preferences) {
						const updatePreferences = {...preferences, company_config_list: payload.data};
						commit("UPDATE_PREFERENCE", updatePreferences);
						await IndexedDB.update("preferences", updatePreferences, userInfo.uid);
						resolve(preferences);
					} else {
						await IndexedDB.save(
							"preferences",
							{...state, company_config_list: payload.data},
							userInfo.uid
						);
						commit("UPDATE_PREFERENCE", state);
						resolve(state);
					}
				} catch (error) {
					console.error(error);
				}
			})();
		});
	},
	getAllPreferences() {
		return IndexedDB.getAll("preferences");
	},
	getPreferences(state) {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		return IndexedDB.getKey("preferences", userInfo.uid);
	},
	updateCompanyConfigListPreferences({commit, state, dispatch}, newConfig) {
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					const preferences = await dispatch("getPreferences");
					const configurationList = [...preferences.company_config_list];
					const configIndex = configurationList.findIndex(
						(config) => config.type_config_id === newConfig.type_config_id
					);
					if (preferences && configIndex >= 0) {
						configurationList[configIndex].config_json = newConfig.config_json;
						const updatePreferences = {...preferences, company_config_list: configurationList};
						commit("UPDATE_PREFERENCE", updatePreferences);
						await IndexedDB.update("preferences", updatePreferences, userInfo.uid);
						resolve(state.company_config_list);
					} else {
						throw new Error({message: "Configuration no found"});
					}
				} catch (error) {
					reject(error);
				}
			})();
		});
	},
};
